<div class="header-container">
  <app-layout-main size="medium" padding="xs">
    <div class="header">
      <div class="header__left">
        @if (showAction()) {
          @if (isMediumAndAbove()) {
            <a
              nz-button
              nzGhost
              nzType="link"
              [routerLink]="actionLink()!"
              [nz-tooltip]="actionLabel()"
            >
              <nz-icon nzType="arrow-left" nzTheme="outline" />
              {{ actionLabel() }}
            </a>
          } @else {
            <a
              nz-button
              nzGhost
              nzType="link"
              [routerLink]="actionLink()!"
              [nz-tooltip]="actionLabel()"
            >
              <nz-icon
                nzType="arrow-left"
                nzTheme="outline"
                class=".only-icon"
              />
            </a>
          }
        }
      </div>

      <a class="header__logo" [routerLink]="['projects']" title="projects list">
        <img
          [src]="'logotype_leoch_horizontal.svg' | imgFolder: 'logo'"
          alt="logo"
        />
      </a>

      <div class="header__right">
        <button nz-button nz-dropdown nzGhost [nzDropdownMenu]="menu">
          {{ displayName() }}
          <nz-icon nzType="down" />
        </button>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            @for (item of accountMenuItems(); track item.id) {
              @if (item.show()) {
                <li
                  nz-menu-item
                  (click)="item.action()"
                  [attr.title]="item.title"
                >
                  <nz-icon [nzType]="item.icon" nzTheme="outline" />
                  {{ item.label }}
                </li>
              }
            }
          </ul>
        </nz-dropdown-menu>
      </div>
    </div>
  </app-layout-main>
</div>
